/**
 * O arquivo é de áudio?
 *
 * Decidido pelo MIME type, e não pela extensão: `getFileType` só mapeia
 * `audio/mpeg` e `audio/wav`, então `audio/ogg`, `audio/flac`, `audio/aac` e
 * companhia cairiam no ícone genérico. O prefixo `audio/` cobre todos de uma
 * vez, e é o mesmo sinal que o navegador usa para decidir se sabe tocar o
 * arquivo.
 *
 * Também é o que separa `audio/mp4` de `video/mp4` — a extensão sozinha não
 * distingue os dois.
 */
export const isAudioMime = (mimeType?: string): boolean =>
  Boolean(mimeType?.toLowerCase().trim().startsWith('audio/'));

export default isAudioMime;
